import * as React from "react"
import UnauthorizedLayout from "../../components/layouts/UnauthorizedLayout"
import LoginComponent from "../../components/screens/login/LoginComponent"
import Head from "next/head"

const LoginPage = () => {
    return (
        <>
            <Head>
                <title>Sign In - Figure Manage</title>
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            </Head>
            <UnauthorizedLayout>
                <LoginComponent />
            </UnauthorizedLayout>
        </>
    )
}

export default LoginPage
